import { RedoShopifyDeliveryMethodType } from "@redotech/redo-fulfillment-group-common/fulfillment-delivery-method-type";
import {
  FulfillmentGroupData,
  getSelectedRate,
} from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { canPurchaseLabelStatus } from "@redotech/redo-fulfillment-group-common/fulfillment-group-status";
import { t } from "@redotech/redo-i18n";

/** EasyPost marks the errors it relays from carriers "rate_error". */
const ERROR_MESSAGE_TYPES: ReadonlySet<string> = new Set([
  "error",
  "rate_error",
]);

type LabelPurchaseGroup = Pick<
  FulfillmentGroupData,
  | "status"
  | "deliveryMethod"
  | "selectedShippingRate"
  | "availableShipmentRates"
  | "ratesErrorMessage"
  | "ratesPendingSince"
  | "shipmentMessages"
>;

export function isLabelPurchasable(group: LabelPurchaseGroup): boolean {
  return (
    group.deliveryMethod === RedoShopifyDeliveryMethodType.Shipping &&
    canPurchaseLabelStatus(group.status) &&
    !group.ratesPendingSince &&
    !group.ratesErrorMessage &&
    !!getSelectedRate({
      selectedShippingRate: group.selectedShippingRate,
      availableRates: group.availableShipmentRates?.rates,
    })
  );
}

export function getLabelPurchaseSkipReasons(
  group: LabelPurchaseGroup,
): string[] {
  if (!canPurchaseLabelStatus(group.status)) {
    return [t("This fulfillment is not open for label purchase.")];
  }
  if (group.ratesPendingSince) {
    return [t("Shipping rates are still loading.")];
  }
  if (group.ratesErrorMessage) {
    return [group.ratesErrorMessage];
  }
  const messages = Object.values(group.shipmentMessages ?? {})
    .flat()
    .filter(
      (message) =>
        !message.ignored && ERROR_MESSAGE_TYPES.has(message.type ?? ""),
    )
    .flatMap((message) => (message.message ? [message.message] : []));
  return messages.length > 0
    ? [...new Set(messages)]
    : [t("No available shipping rate selected.")];
}
